import { render, staticRenderFns } from "./CorporateVendorDetailModal.vue?vue&type=template&id=0ae4b2a5"
import script from "./CorporateVendorDetailModal.vue?vue&type=script&lang=js"
export * from "./CorporateVendorDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CorporateVendorDetailModal.vue?vue&type=style&index=0&id=0ae4b2a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports